module.exports = __webpack_public_path__ + "static/media/slack.c8953559.png";